













































































































































import SimpleMap from '../../core/components/SimpleMap.vue';
import Input from '../../core/components/Input.vue';
import InfoIcon from '../../core/components/InfoIcon.vue';
import $ from 'jquery';
import {
    EventBus,
    hasElements,
    TypeEventBus,
    sortObjectByPropertyName,
    checkIfIDExistsInArray,
    emailValidator,
    formRules,
    passwordCheck,
    updateCredentials
} from '../../core/utils';
import { Destroyed } from '../../core/decorators';
import { Component, Prop, Mixins, Vue, Watch, Emit } from 'vue-property-decorator';
import { PRIVILEGE_KEYS, PRIVILEGE_TYPES } from '../../core/utils/privileges';
import {
    MsgBox,
    Button,
    Combobox,
    PlusEyeButtons,
    Breadcrums,
    CloseConfirmationModal
} from '../../core/components';
import {
    AuthStoreHelper,
    RootStoreHelper,
    CompanyStoreHelper,
    StoreHelper,
    NotificationStoreHelper
} from '../../core/mixins';
import multiselect from 'vue-multiselect';
import Axios from 'axios';
import Loading from 'vue-loading-overlay';
import { config } from 'rxjs';
import { UserChangeEmail, UserChangePassword, UserList } from '../models/Users';
import { getSavedCredentials } from '../helpers';
import { UserService } from '../../core/api';
import { error } from 'highcharts';

@Component({
    components: {
        Loading,
        Combobox,
        Button,
        Input,
        InfoIcon
    }
})
export default class ModalUserPreferences extends Mixins(
    AuthStoreHelper,
    StoreHelper,
    RootStoreHelper,
    CompanyStoreHelper,
    NotificationStoreHelper
) {
    @Prop({default: false}) visible: boolean;
    @Prop({default: false}) isAdmin: boolean; //true > modifica la contraseña usuario Smartway desde pagina de Empresas
    @Prop({default: null}) userInfo: UserList; 
    email: string = '';
    oldPassword: string = '';
    newPassword: string = '';
    shouldBeEmail: string = 'Se necesita un e-mail para poder cambiar la contraseña';
    shouldBeEmailToRestore: string = 'Se necesita un e-mail para poder reestablecer la contraseña';
    restorePasswordInfo: string = 'Se enviará una nueva contraseña al correo para que pueda acceder';
    oldPasswordFieldType: string = 'password';
    oldPasswordRules: Array<any> = [
        v => !!v || "Ingrese la contraseña",
    ];
    changingPassword: boolean = false;
    pendingResetPassword: boolean = false;

    emailRules: Array<any> = formRules.email;
    
    get newPasswordRules(){
         return [
            v => !!v || "Ingrese la contraseña",
            v => (v && passwordCheck(v, this.oldPassword)) || 'Las contraseñas no coinciden',
        ]
    }

    get existsEmail(){
        return this.email !== '' ? true : false
    }

    updateOldPassword(value){
        this.oldPassword = value;
    }
    updateNewPassword(value){
        this.newPassword = value;
    }

    updateEmailField(value){
        this.email = value
    }
    get modalTitle(){
        if(this.isAdmin){
            return `Configurar usuario: <b>${this.userInfo.username}</b>`
        }
        return 'Configuración personal'
    }

    showLoadingDialog(msg){
        this.$_showLoadingDialog(msg);
    }
    showSuccessLoadingDialog(response, alternative_msg){
        this.$_successLoadingDialog({
            response: response,
            alternative_msg: alternative_msg
        });
        this.closeModal();
    }
    showCatchLoadingDialog(error, alternative_msg){
        this.$_catchLoadingDialog({
            response: error.response.data || {},
            alternative_msg: alternative_msg
        });
    }

    sendNewPasswordToMail(){
        this.pendingResetPassword = true;
        UserService.sendNewPasswordToEmail(this.userInfo.id, this.email)
        .then((res) => {
            this.pendingResetPassword = false;
             this.$_successPatchRecipients(res.message);
        }).catch((err) => {
            this.pendingResetPassword = false;
            this.showCatchLoadingDialog(err, 'No se pudo enviar la nueva contraseña al correo')
        })
    }

    loadUserInfo(){
        this.email = this.userInfo.email;
    }


    get getData() {
        return {
           
        };
    }
    
    get canChangeEmail() {
        return this.email !== '' && emailValidator(this.email) == true
    }
    get canChangePassword() {
        if(this.oldPassword === '' || this.newPassword === '' || !this.existsEmail){
            return false
        }
        return passwordCheck(this.oldPassword, this.newPassword) !== true ? false : true
  }

   
    @Emit()
    closeModal() {}

    submitChangeEmail() {
        if(this.isAdmin){
            //si modifico mi propio usuario actualizo las credenciales
            if(this.userInfo.username === this.$_getUserName){
                this.modifyCurrentUserOwnEmail();
            }else{
                 //modificar cualquier usuario en listado de Usuarios
                 this.modifyUserEmail();
            }
        }else{
            //modificar mi propio usuario logueado
            this.modifyCurrentUserOwnEmail()
        }
    }

    modifyUserEmail(){
        UserService.changeEmailToUser(
            this.userInfo.id,
            this.email
        ).then((res) => {
            this.$_successPatchRecipients(res.data.message);
            this.updateUserInUsersList(res.data.user.id, res.data.user.email)
        }).catch((e) => {
            this.$_catchLoadingDialog({
                response: e.response.data || {},
                alternative_msg: 'No se pudo modificar el e-mail'
            });
        })
    }

    modifyCurrentUserOwnEmail(){
        let config: UserChangeEmail = {
            user_email: this.email
        };
        UserService.modifyCurrentUserEmail(config)
        .then((res) => {
            this.$_successPatchRecipients(res.data.message);
            this.updateCurrentUserEmailInCredentials();
        }).catch((e) => {
            this.$_catchLoadingDialog({
                response: e.response.data || {},
                alternative_msg: 'Falló el listado de usuarios'
            });
        })
    }

    submitChangePassword(){
        let data: UserChangePassword = {
            user_password: this.newPassword
        }
        this.changingPassword = true;

         UserService.modifyCurrentUserPassword(data)
        .then((res) => {
            this.changingPassword = false;
            this.$_successPatchRecipients(res.data.message);
        }).catch((e) => {
            this.changingPassword = false;
            this.$_catchLoadingDialog({
                response: e.response.data || {},
                alternative_msg: 'Falló cambiar contraseña'
            });
        })
    }

    @Emit()
    updateUserInUsersList(id: number, newEmail: string){}

    updateCurrentUserEmailInCredentials(){
        let currentCredentials = getSavedCredentials();
        if(currentCredentials){
            updateCredentials({
                ...currentCredentials,
                email: this.email,
                show_email_popup: false
            });
            this.updateUserInUsersList(currentCredentials.id, this.email);
        }
        
    }

    doNothing() {}

    mounted() {
        this.loadUserInfo();
    }
}
